export const hardwareHeader = {
  title: "أجهزة الكاشير والملحقات — جاهزة للتسليم",
  storeLabel: "إسناد ستور",
  storeUrl: "https://esnadstore.com",
  subtitle: "تسوّق كل ما تحتاجه عبر متجرنا الإلكتروني،",
};

export const HARDWARE_CARDS = [
  // حزمة/باقات شاملة للأعمال
  {
    eyebrow: "حل متكامل",
    title: "باقات شاملة للأعمال",
    desc: "تجميعة مدروسة تشمل جهاز الكاشير والملحقات الأساسية لتبدأ فورًا.",
    priceText: "— ريال",
    actions: [
      {
        label: "استعرض الباقات",
        variant: "contained",
        href: "https://esnadstore.com/category/mKYOoE",
      },
    ],
  },

  // أجهزة كاشير
  {
    eyebrow: "نقاط بيع",
    title: "أجهزة كاشير",
    desc: "أنظمة كاشير احترافية تلبي احتياجات الأنشطة التجارية.",
    priceText: "— ريال",
    actions: [
      {
        label: "تصفح الأجهزة",
        variant: "outlined",
        href: "https://esnadstore.com/category/XrdNzA",
      },
    ],
  },

  // طابعات فواتير حرارية
  {
    eyebrow: "فواتير أسرع",
    title: "طابعات فواتير حرارية",
    desc: "سرعة طباعة عالية وتوافق مع معظم نقاط البيع.",
    priceText: "— ريال",
    actions: [
      {
        label: "تصفح الطابعات",
        variant: "outlined",
        href: "https://esnadstore.com/category/OwxPyg",
      },
    ],
  },

  // طابعات باركود
  {
    eyebrow: "وسوم دقيقة",
    title: "طابعات باركود",
    desc: "طباعة احترافية للباركود مع جودة وثبات عاليين.",
    priceText: "— ريال",
    actions: [
      {
        label: "تصفح طابعات الباركود",
        variant: "outlined",
        href: "https://esnadstore.com/category/ZyKgQW",
      },
    ],
  },

  // بوابات
  {
    eyebrow: "حلول متقدمة",
    title: "بوابات",
    desc: "بوابات أمان ومراقبة للمنافذ التجارية.",
    priceText: "— ريال",
    actions: [
      {
        label: "تصفح البوابات",
        variant: "outlined",
        href: "https://esnadstore.com/category/gVKKVZ",
      },
    ],
  },

  // أجهزة كمبيوتر
  {
    eyebrow: "أداء قوي",
    title: "أجهزة كمبيوتر",
    desc: "أجهزة مكتبية ومحمولة بأداء عالي لتشغيل برامج نقاط البيع.",
    priceText: "— ريال",
    actions: [
      {
        label: "تصفح الكمبيوترات",
        variant: "outlined",
        href: "https://esnadstore.com/category/mnDDnY",
      },
    ],
  },
];

export const hardwareCTA = {
  title: "لا تعرف أي حزمة تناسب نشاطك؟",
  subtitle:
    "سنساعدك في اختيار الأجهزة والبرامج الأنسب، حسب حجم النشاط وعدد الفروع.",
  primaryLabel: "جرّب الآن مجان",
};
